export default __webpack_public_path__ + "static/media/1.a0733ba2.webp";